import React from 'react';
import { Reveal } from './Reveal';
const audiences = ['Tarot Readers & Card Practitioners', 'Reiki Healers & Energy Therapists', 'Chakra & Wellness Students', 'Spiritual Coaches & Holistic Practitioners', 'Crystal Healers & Dowsing Students', 'Anyone Building a Serious Spiritual Practice'];
export function ProfessionalAudience() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-191" data-mp="243jck3lihtw">
      <Reveal className="mx-auto max-w-5xl text-center" data-id="element-192" data-mp="72er8pabyi9h">
        <h2 className="font-serif text-4xl leading-tight text-navy sm:text-5xl" data-id="element-193" data-mp="73y74es2qraq">
          🔮 Designed for Serious <span className="text-sage" data-id="element-194" data-mp="c2j5s9roh2x2">Energy Practitioners</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate sm:text-lg" data-id="element-195" data-mp="g332xdc946j7">
          If you work with energy, study spiritual wellness, or want a complete reference system —
          this library was built for you.
        </p>
        <ul className="mt-10 flex flex-wrap justify-center gap-3" data-id="element-196" data-mp="2ms80iymou4ki">
          {audiences.map(audience => <li key={audience} className="rounded-full border border-amber/50 bg-surface px-4 py-2.5 text-sm font-semibold text-navy shadow-premium" data-id="element-197" data-mp="1a218rx1nlb7c">
              ✅ {audience}
            </li>)}
        </ul>
      </Reveal>
    </section>;
}